import { sessionService } from '@/providers/services/auth/session';
import { USER_TYPE } from '@/utils/constants';
import { Vue, Component } from 'vue-property-decorator';

@Component({
    name: 'my-gooru',
})
export default class Users extends Vue {

    // Properties

    private get session() {
        return sessionService.getSession();
    }

    private userTypeList: any = USER_TYPE;

    private userType: string = '';

    private myGooruMenu: Array<{route: string, icon: string, label: string}> = [
        {
            route: '/my-gooru/access-code',
            icon: 'key',
            label: 'Access Code',
        },
        {
            route: '/my-gooru/nudge-config',
            icon: 'settings',
            label: 'Nudge Config',
        },
        {
            route: '/my-gooru/nudge-types',
            icon: 'import_contacts',
            label: 'Nudge Types',
        },
        {
            route: '/my-gooru/topic-list',
            icon: 'key',
            label: 'Topics Config',
        },
        {
            route: '/my-gooru/subject-list',
            icon: 'key',
            label: 'Subject/Level Config',
        },
    ];

    private activeRouteObj: any = null;

}
